/**
 * @file 弹窗组件
 * @author wangzian@baidu.com
 * */

import {Component} from 'san';
import './index.scss';

export default class HugModal extends Component {
    static template = `
        <div class="c-hug-modal" s-if="{{value}}">
            <div class="mask" on-click="maskClose"></div>
            <div class="modal {{mode}}">
                <slot></slot>
                <div on-click="topClose" class="icon-wrap" s-if="{{topCloseVisible}}">
                   X
                </div>
                <img
                    class="close-btn"
                    on-click="bottomClose"
                    s-if="bottomCloseVisible"
                    src="../../assets/image/modal-close.png"/>
            </div>
        </div>
    `;

    initData() {
        return {
            allowMaskClose: false,
            // 模式：白色/黑色 取值：white/black
            mode: 'black',
            topCloseVisible: false
        };
    }

    maskClose() {
        if (this.data.get().allowMaskClose) {
            this.close();
        }
    }

    close() {
        this.fire('close');
        this.data.set('value', false);
    }

    topClose() {
        this.close();
    }

    // 查看更多
    moreClick() {
        this.fire('moreclick');
    }

}
